import { jsxs, jsx, Fragment } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { ListItemButton, Typography, ListItemText } from "@mui/material";
import { LeftSlotWrapper } from "../styles/containers.es.js";
function Interactive({
  primary,
  secondaryText,
  leftSlot,
  rightSlot,
  secondRightSlot,
  ...rest
}) {
  return /* @__PURE__ */ jsxs(ListItemButton, { "data-testid": rest == null ? void 0 : rest.buttonid, ...rest, children: [
    leftSlot && /* @__PURE__ */ jsx(LeftSlotWrapper, { children: leftSlot }),
    /* @__PURE__ */ jsx(ListItemText, { primary: /* @__PURE__ */ jsx(Typography, { variant: "body1", children: primary }), secondary: /* @__PURE__ */ jsx(Typography, { variant: "body2", children: secondaryText }) }),
    rightSlot && /* @__PURE__ */ jsxs(Fragment, { children: [
      rightSlot,
      secondRightSlot
    ] })
  ] });
}
export {
  Interactive
};
//# sourceMappingURL=interactive.es.js.map
